import { Tooltip, Position } from "evergreen-ui"
import Figure from "./figure"
import { range } from "lodash"
import SvgFigure from "../../components/svgFigure"

const neurons = [379, 406, 385, 343, 342, 388, 340, 330, 349, 324]

export default class DatasetFigure extends Component {
  state = { activeNeuron: neurons[0] }

  render() {
    const { activeNeuron } = this.state

    const imageCount = 10
    const exampleUrl = (neuron, layer, bin, index) =>
      `https://storage.googleapis.com/clarity-public/nick/dataset_examples/${layer}/${neuron}/bin${bin}/image${index}.jpg`

    const Examples = ({ bin }) => (
      <Surface
        flexFlow="row"
        flexWrap="wrap"
        width={321}
        borderRadius={6}
        overflow="hidden"
        height={128}
      >
        {range(imageCount).map(index => (
          <img
            style={{ margin: 0, padding: 0 }}
            width={64}
            src={exampleUrl(activeNeuron, "mixed3b", bin, index)}
          />
        ))}
      </Surface>
    )

    const Bar = () => (
      <Surface
        background="rgba(0, 0, 0, 0.2)"
        width={2}
        borderRadius={16}
        height={80}
        marginX={15}
      />
    )

    const circles = [
      { x: 205.69, y: 0, neuron: 406 },
      { x: 313.65, y: 33.89, neuron: 385 },
      { x: 411.37, y: 209.63, neuron: 343 },
      { x: 383, y: 303.41, neuron: 342 },
      { x: 313.65, y: 383.79, neuron: 388 },
      { x: 205.69, y: 411.37, neuron: 324 },
      { x: 103.24, y: 383.79, neuron: 340 },
      { x: 20.49, y: 302.62, neuron: 330 },
      { x: 0, y: 209.63, neuron: 349 },
      { x: 97.72, y: 33.89, neuron: 379 },
    ]

    const scale = 0.7
    const diameter = 412 * scale
    const highlightColor = `rgba(228, 118, 88, 0.9)`

    return (
      <Figure>
        <FigureHeading>Dataset Example Activations</FigureHeading>
        <Surface flexFlow="row" alignItems="center">
          <Surface position="relative">
            <Surface
              width={diameter}
              height={diameter}
              borderRadius={diameter}
              background="white"
              style={{ border: `1px solid ${highlightColor}` }}
              margin={30}
              marginRight={65}
            />
            {circles.map(({ x, y, neuron }) => (
              <img
                src={neuronFeatureVis("inceptionv1", "mixed3b", neuron)}
                width={60}
                key={neuron}
                onMouseEnter={() => this.setState({ activeNeuron: neuron })}
                style={{
                  borderRadius: 60,
                  position: "absolute",
                  left: x * scale,
                  top: y * scale,
                  border: `3px solid ${
                    activeNeuron === neuron ? highlightColor : "transparent"
                  }`,
                  transition: "300ms ease-out all",
                }}
              />
            ))}
          </Surface>
          <Surface>
            <Surface flexFlow="row" marginY={10} alignItems="center">
              <Examples bin={0} neuron={activeNeuron} />
              <Bar />
              <Surface alignItems="flex-start" width={220}>
                <Text fontWeight={600}>Maximum Activations</Text>
                <Text>Examples match the neuron's arc</Text>
              </Surface>
            </Surface>
            <Surface flexFlow="row" marginY={10} alignItems="center">
              <Examples bin={2} neuron={activeNeuron} />
              <Bar />
              <Surface alignItems="flex-start" width={220}>
                <Text fontWeight={600}>Activations Near Zero</Text>
                <Text>Examples form mostly straight lines</Text>
              </Surface>
            </Surface>
            <Surface flexFlow="row" marginY={10} alignItems="center">
              <Examples bin={4} neuron={activeNeuron} />
              <Bar />
              <Surface alignItems="flex-start" width={220}>
                <Text fontWeight={600}>Negative Activations Before Relu</Text>
                <Text>Examples oppose the neuron's arc</Text>
              </Surface>
            </Surface>
          </Surface>
        </Surface>
      </Figure>
    )
  }
}
